var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import Timeline from '@mui/lab/Timeline';
import TimelineItem from '@mui/lab/TimelineItem';
import TimelineSeparator from '@mui/lab/TimelineSeparator';
import TimelineConnector from '@mui/lab/TimelineConnector';
import TimelineContent from '@mui/lab/TimelineContent';
import TimelineOppositeContent from '@mui/lab/TimelineOppositeContent';
import TimelineDot from '@mui/lab/TimelineDot';
import * as ServiceHistorique from '../services/historique';
import { useEffect, useState } from 'react';
import * as Icons from './Icons';
import { Loader } from './Loader';
import moment from 'moment';
import { RightIcon, InfoIcon } from './Icons';
import { getBackgroundColor, getColors } from './Classes';
import { Chip, Stack, Tooltip, Card } from '@mui/material';
import { FONT_SIZE } from '../theme';
import { Typography } from './Typography';
export var TimelineVertical = function (_a) {
    var Model = _a.Model, ModelId = _a.ModelId;
    var _b = useState([]), historiques = _b[0], setHistoriques = _b[1];
    var _c = useState(true), loading = _c[0], setLoading = _c[1];
    var palette = getColors();
    useEffect(function () {
        var getDatas = function () { return __awaiter(void 0, void 0, void 0, function () {
            var stateHistoriques;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, ServiceHistorique.getHistoriqueListe(Model, ModelId)];
                    case 1:
                        stateHistoriques = _a.sent();
                        setHistoriques(stateHistoriques ? stateHistoriques : []);
                        setLoading(false);
                        return [2 /*return*/];
                }
            });
        }); };
        getDatas();
    }, [Model, ModelId]);
    if (loading) {
        return _jsx(Loader, {});
    }
    return (_jsx(_Fragment, { children: historiques.length > 0 && (_jsx(Timeline, __assign({ className: "p-none" }, { children: historiques.map(function (historique, index) {
                var Icon = historique.Icone ? Icons[historique.Icone] : InfoIcon;
                var Color = historique.Color ? historique.Color : 'primary';
                return (_jsxs(TimelineItem, { children: [_jsxs(TimelineOppositeContent, __assign({ sx: {
                                fontSize: FONT_SIZE.SMALL,
                                maxWidth: 100,
                                minWidth: 100,
                                paddingLeft: 0,
                            }, color: "textSecondary" }, { children: [_jsx(Typography, __assign({ variant: "body2" }, { children: moment(historique.Date).format('DD MMM YYYY') })), _jsx(Typography, __assign({ variant: "inherit", className: "text-smaller" }, { children: moment(historique.Date).format('HH:mm') }))] })), _jsxs(TimelineSeparator, { children: [_jsx(TimelineConnector, {}), _jsx(TimelineDot, __assign({ sx: getBackgroundColor(palette, Color) }, { children: _jsx(Icon, {}) })), _jsx(TimelineConnector, {})] }), _jsx(TimelineContent, __assign({ sx: { width: 0 }, className: "flex items-center pr-none" }, { children: _jsx(Stack, __assign({ className: "w-full" }, { children: _jsx(Chip, { className: "w-full justify-between", label: historique.Titre, sx: __assign(__assign({}, getBackgroundColor(palette, Color)), (historique.IsPrimary ? {} : { opacity: 0.7 })), color: Color, onDelete: historique.Message || historique.getLien
                                        ? function () {
                                            if (historique.getLien) {
                                                window.location.href = historique.getLien;
                                            }
                                        }
                                        : null, deleteIcon: historique.Message || historique.getLien ? (historique.Message ? (_jsx(Tooltip, __assign({ disableInteractive: true, title: _jsx(Card, __assign({ variant: "outlined", className: "p-small" }, { children: _jsx("div", { dangerouslySetInnerHTML: {
                                                    __html: historique.Message,
                                                } }) })) }, { children: _jsx(InfoIcon, {}) }))) : (_jsx(RightIcon, {}))) : (_jsx(_Fragment, {})) }) })) }))] }, index));
            }) }))) }));
};
//# sourceMappingURL=TimelineVertical.js.map